export default "__VITE_ASSET__BcK6sF4Y__"